import React from "react";
import { Route, Routes } from "react-router-dom";
import GeneralInstructions from "../Pages/BRSR/General";
import BRSRSectionA from "../Pages/BRSR/SectionA";
import BRSRSectionB from "../Pages/BRSR/SectionB";
import GeneralInstructionsSectionC from "../Pages/BRSR/SectionC";
import SectionC from "../Pages/BRSR/SectionC/SectionC";
import Principle1 from "../Pages/BRSR/SectionC/Principle1";
import Principle2 from "../Pages/BRSR/SectionC/Principle2";
import Principle3 from "../Pages/BRSR/SectionC/Principle3";
import Principle4 from "../Pages/BRSR/SectionC/Principle4";
import Principle5 from "../Pages/BRSR/SectionC/Principle5";
import Principle6 from "../Pages/BRSR/SectionC/Principle6";
import Principle7 from "../Pages/BRSR/SectionC/Principle7";
import Principle8 from "../Pages/BRSR/SectionC/Principle8";
import Principle9 from "../Pages/BRSR/SectionC/Principle9";
import BrsrList from "../Pages/BRSR/List";
import SectionAReview from "../Components/BRSR/BrsrReview";
import BrsrDownload from "../Pages/BRSR/List/BrsrDownload.jsx";
import BrsrDownload_1 from "../Pages/BRSR/List/BrsrDownload_1.jsx";
import BRSRReport from "../Pages/BRSRReport/Report.jsx";

export const BRSRRoutes = [
      { path:"/brsr" ,element:<BrsrList />},
      { path:"/brsr/instructions/:id", element:<GeneralInstructions />},
      { path:"/brsr/section-a/:id", element:<BRSRSectionA />},
      { path:"/brsr/section-b/:id" ,element:<BRSRSectionB />} ,
      {
        path:"/brsr/section-c/instructions/:id",
        element:<GeneralInstructionsSectionC />},
      { path:"/brsr/section-c/:id" ,element:<SectionC />},
      { path:"/brsr/section-c/principle1/:id", element:<Principle1 />},
      { path:"/brsr/section-c/principle2/:id", element:<Principle2 />},
      { path:"/brsr/section-c/principle3/:id", element:<Principle3 />},
      { path:"/brsr/section-c/principle4/:id" ,element:<Principle4 />},
      { path:"/brsr/section-c/principle5/:id" ,element:<Principle5 />},
      { path:"/brsr/section-c/principle6/:id" ,element:<Principle6 />},
      { path:"/brsr/section-c/principle7/:id" ,element:<Principle7 />},
      { path:"/brsr/section-c/principle8/:id" ,element:<Principle8 />},
      { path:"/brsr/section-c/principle9/:id" ,element:<Principle9 />},
      { path:"/brsr/review/:id" ,element:<SectionAReview />},
      // { path:"/brsr/preview/:id" ,element:<BrsrDownload />},
      { path:"/brsr/preview-download/:id", element:<BRSRReport />},
]
